import React from 'react'
import pickupTruck from '../images/pickup-truck.png'
import rentalServiceImg from '../images/rental-service-img.jpeg'
const dumpsterDetails = [
    {
        yards: "10",
        limit: "1",
        pickup: 4,
        special: 425,
        price: 450
    },
    {
        yards: "15",
        limit: "1.5",
        pickup: 6,
        special: 525,
        price: 550
    },
    // {
    //     yards: "15",
    //     limit: "1.5",
    //     bullets: [
    //         "$495",
    //         "14 day rental ($25 extra charge for every day after 14)",
    //         "Volume is roughly equal to 4 pickup trucks",
    //         "3 day special is available for $440"
    //     ],
    //     pickup: 6,
    //     special: 440,
    //     price: 495
    // }
];


function Rentals() {

    const rentalOptions = dumpsterDetails.map( (option) => {
        let truckClass = "pickup-trucks-container " ;
        if(option.pickup === 4){
            truckClass += "four-trucks";
        }else{
            truckClass += "six-trucks";
        }

        const imgArray = [];
        for(let i = 0; i < option.pickup; i++){
            
            imgArray.push(<img classname= "pickup-truck" src={pickupTruck} alt="Pickup truck" />);
        }
        console.log(option.pickup + " Pickups")
        return(
            <div className= "dumpster-option">
                <h3 className= "dumpster-header">{option.yards} Yard Dumpster ({option.limit} ton limit)</h3>
                <div className= "size-comparison-container">
                        <div className= "size-details">
                            <h4>Rental Details </h4>
                            {/* <h5> {option.limit} Ton Limit</h5> */}
                            <ul>
                                <li>- ${option.price}</li>
                                <li>- 14 day rental ($25 extra charge for every day after 14)</li>
                                <li>- Volume is roughly equal to {option.pickup} pickup trucks</li>
                                <li>- 3 day special is available for ${option.special}</li>
                            </ul>
                        </div>
                    <div className= "approx">≈</div>
                    <div className= {truckClass}>
                        {imgArray}
                    </div>
                </div>
            </div>
        )
    });


  return (
    <>
        <h2>Rentals</h2>
        <section id= "rental-service" className= "service-container" >
            <div id= "rental-service-description" className= "individual-service-container">
                <div id= "rental-service-img-container">
                    <img src={rentalServiceImg} alt="Ideal Disposal Dumpster" />
                </div>
                <div id= "rental-description-container" className = "service-description">
                    <p >Choose Ideal Disposal for top-notch dumpster rental services, perfect for everything from home cleanouts to construction debris removal. We're committed to offering competitive rates and exceptional customer service. If you have questions, we're just a call away.
                        <br></br>
                        Our offerings include:
                    </p>
                    <ul>
                        <li>- 10-yard and 15-yard dumpsters.</li>
                        <li>- Standard 14-day rentals, with the flexibility for longer terms at an additional $25/day.</li>
                        <li>- Attractive three-day special rates.</li>
                    </ul>
                    <p>Contact us today to discuss your needs and find the perfect dumpster solution for your project.</p>
                </div>
            </div>
            <div id= "all-dumpster-options">
                {rentalOptions}
                {/* Add all of the extra cost and non-accepted Items */}
                
            </div>
            <section id= "special-items-section">
                    <h3 className= "dumpster-header">Special Items</h3>
                    <div id= "special-items-container">
                        <div className="list-container">
                                <h4>Non-Accepted Items</h4>
                                <ul>
                                    <li>Animal Carcasses</li>
                                    <li>Asbestos</li>
                                    <li>Closed Drums
    </li>
                                    <li>Flammable and Explosive Items</li>
                                    <li>Fluorescent Light Bulbs</li>
                                    <li>Gas and Oil</li>
                                    <li>Grease</li>
                                    <li>Household Garbage (Food Waste)</li>
                                    <li>Human Waste</li>
                                    <li>Liquids and Solvents</li>
                                    <li>Medical Waste</li>
                                    <li>Paint and Paint Thinner</li>
                                </ul>
                            </div>
                            <div className="list-container">
                                <h4>Extra Charge Items</h4>
                                <table>
                                  
                                    <tbody>
                                        <tr>
                                            <td>Computer Monitors</td>
                                            <td>$50</td>
                                        </tr>
                                        <tr>
                                            <td>Freon Appliances</td>
                                            <td>$60</td>
                                        </tr>
                                        <tr>
                                            <td>Oxygen Tanks</td>
                                            <td>$30</td>
                                        </tr>
                                        <tr>
                                            <td>Propane Tanks</td>
                                            <td>$30</td>
                                        </tr>
                                        <tr>
                                            <td>Tires</td>
                                            <td>$35</td>
                                        </tr>
                                        <tr>
                                            <td>Truck Tires</td>
                                            <td>$50</td>
                                        </tr>
                                        <tr>
                                            <td>Mattresses</td>
                                            <td>$100</td>
                                        </tr>
                                        <tr>
                                            <td>Box Springs</td>
                                            <td>$100</td>
                                        </tr>
                                        <tr>
                                            <td>TV's</td>
                                            <td>$50</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </section>
        </section>
    </>
  )
}

export default Rentals;